/**
 *
 *
 *
 *
 *
 *
 *
 */
function macrotasks(timeout = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, timeout);
    });
}
/**
 *
 *
 *
 *
 *
 */
async function microtasks(count = 1) {
    await Promise.all(Array.from({ length: count }, () => Promise.resolve()));
}
/**
 *
 *
 *
 *
 *
 */
function executionOf(stuff) {
    stuff();
    return Promise.resolve();
}

export { executionOf, macrotasks, microtasks };
/*                              */
